(function(){
  if (window.__zvHomeInit) return;
  window.__zvHomeInit = true;

  /* ---- Scroll reveal ---- */
  var revealEls = document.querySelectorAll('.zv-reveal');
  if ('IntersectionObserver' in window && revealEls.length){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting){
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -6% 0px' });
    revealEls.forEach(function(el){ io.observe(el); });
  } else {
    revealEls.forEach(function(el){ el.classList.add('is-visible'); });
  }

  /* ---- Light parallax on hero orbs (skipped if reduced motion) ---- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hero = document.querySelector('[data-zv-hero]');
  if (hero && !reduceMotion && window.matchMedia('(min-width: 750px)').matches){
    var orbs = hero.querySelectorAll('.zv-hero__orb');
    var ticking = false;
    window.addEventListener('scroll', function(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        var rect = hero.getBoundingClientRect();
        var progress = Math.min(Math.max(-rect.top / (rect.height || 1), 0), 1);
        orbs.forEach(function(orb, i){
          var depth = i % 2 === 0 ? 26 : -18;
          orb.style.transform = 'translateY(' + (progress * depth) + 'px)';
        });
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---- Smooth-scroll for on-page anchor links ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    var targetId = a.getAttribute('href').slice(1);
    if (!targetId) return;
    a.addEventListener('click', function(e){
      var target = document.getElementById(targetId);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  });

  /* ---- Quiz ---- */
  var quiz = document.querySelector('[data-zv-quiz]');
  if (quiz){
    var steps = Array.prototype.slice.call(quiz.querySelectorAll('[data-zv-step]'));
    var dots = Array.prototype.slice.call(quiz.querySelectorAll('[data-zv-dot]'));
    var resultPanel = quiz.querySelector('[data-zv-result]');
    var resultTitle = quiz.querySelector('[data-zv-result-title]');
    var resultText = quiz.querySelector('[data-zv-result-text]');
    var resultLink = quiz.querySelector('[data-zv-result-link]');
    var restartBtn = quiz.querySelector('[data-zv-restart]');
    var current = 0;
    var scores = {};

    function showStep(index){
      steps.forEach(function(step, i){ step.classList.toggle('is-active', i === index); });
      dots.forEach(function(dot, i){
        dot.classList.toggle('is-active', i === index);
        dot.classList.toggle('is-done', i < index);
      });
      if (resultPanel) resultPanel.classList.toggle('is-active', false);
    }

    function tally(value){
      scores[value] = (scores[value] || 0) + 1;
    }

    function bestUniverse(){
      var best = null, bestScore = -1;
      Object.keys(scores).forEach(function(key){
        if (scores[key] > bestScore){ best = key; bestScore = scores[key]; }
      });
      return best;
    }

    var universes = {
      sommeil: {
        title: 'Univers Sommeil',
        text: 'Vos réponses pointent vers un besoin de mieux dormir et de mieux récupérer la nuit.',
        url: '/collections/sommeil'
      },
      recuperation: {
        title: 'Univers Récupération sportive',
        text: 'Votre corps a besoin de mieux récupérer entre deux efforts.',
        url: '/collections/recuperation'
      },
      confort: {
        title: 'Univers Mobilité & Confort',
        text: 'Le confort au quotidien — assise, posture, détente — semble être votre priorité.',
        url: '/collections/mobilite-confort'
      },
      concentration: {
        title: 'Univers Concentration & travail',
        text: 'Retrouver de la concentration et un cadre de travail plus sain vous parle le plus.',
        url: '/collections/concentration'
      }
    };

    quiz.addEventListener('click', function(e){
      var option = e.target.closest('[data-zv-value]');
      if (option){
        tally(option.getAttribute('data-zv-value'));
        if (current < steps.length - 1){
          current += 1;
          showStep(current);
        } else {
          var winner = universes[bestUniverse()] || universes.sommeil;
          if (resultTitle) resultTitle.textContent = winner.title;
          if (resultText) resultText.textContent = winner.text;
          if (resultLink) resultLink.setAttribute('href', winner.url);
          dots.forEach(function(dot){ dot.classList.add('is-done'); dot.classList.remove('is-active'); });
          if (resultPanel) resultPanel.classList.add('is-active');
        }
        return;
      }
      if (e.target.closest('[data-zv-restart]')){
        current = 0;
        scores = {};
        showStep(0);
      }
    });

    showStep(0);
  }
})();
